module.exports = __webpack_public_path__ + "img/otp-success.ed702a53.webp";